module.exports = __webpack_public_path__ + "static/media/br.50e7a789.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/br.svg
// module id = 1434
// module chunks = 0